module.exports = __webpack_public_path__ + "img/img_003-75x75-2.3f342c12.png";